// extracted by mini-css-extract-plugin
export default {"melodyVideo":"uJ-z","isFullWidth":"vJ-z","landingPageVideo":"wJ-z","play":"xJ-z","iframeVideo":"yJ-z","playHidden":"zJ-z","fullwidth":"AJ-z"};